import { useEffect, useState } from "react";

import uniqBy from "lodash/uniqBy";

import { swSettings } from "app/common/services/swSettings";
import { keywordGroupsQueryClient, keywordGroupsTransforms } from "app/services/keyword-groups";

import type { KWGroupSchema, TopicSchema } from "../components/Topics/types";

export type KWWithFlagSchema = KWGroupSchema & { isAlreadyUsed?: boolean };

export type KeywordsGroupsSchema = {
    sharedKWList: KWWithFlagSchema[];
    ownKWList: KWWithFlagSchema[];
};

const useKeywordsGroups = (createdTopics: TopicSchema[], isTopicsLoading: boolean) => {
    const [keywordsGroups, setKeywordsGroups] = useState<KeywordsGroupsSchema>();

    useEffect(() => {
        const getKeywordsGroups = async () => {
            await keywordGroupsQueryClient.invalidateAll();

            const createdTopicsIds = createdTopics?.map((topic) => topic.topicId) || [];
            const userId = swSettings.user.id;

            const { userGroups, sharedGroups } = await keywordGroupsQueryClient.getAllGroups();

            const dropdownGroups = [
                ...keywordGroupsTransforms.toDropDown(userGroups),
                ...keywordGroupsTransforms.toDropDown(sharedGroups),
            ];

            const uniqDropdownGroupsById = uniqBy(dropdownGroups, "id");
            const ownKwIds = [];

            const sharedKWList: KWWithFlagSchema[] = [];
            const ownKWList: KWWithFlagSchema[] = [];

            uniqDropdownGroupsById.forEach((keyword: KWWithFlagSchema) => {
                const isAlreadyUsed = createdTopicsIds.includes(keyword.id);

                if (Number(keyword.userId) !== userId) {
                    sharedKWList.push({ ...keyword, isAlreadyUsed });

                    return;
                }

                ownKWList.push({ ...keyword, isAlreadyUsed });
                ownKwIds.push(keyword.id);
            });

            const filteredSharedKWList = sharedKWList.filter((keyword) => !ownKwIds.includes(keyword.id));

            setKeywordsGroups({ sharedKWList: filteredSharedKWList, ownKWList });
        };

        if (!isTopicsLoading) {
            void getKeywordsGroups();
        }
    }, [isTopicsLoading, createdTopics]);

    return { keywordsGroups };
};

export default useKeywordsGroups;
